<template lang="pug">
v-container.px-10(fluid)
  v-progress-linear(
    :active="loading",
    indeterminate,
    color="white",
    absolute,
    top
  )
  v-row.text-center(v-if="!entity")
    v-col.py-0
      h2.primary--text {{$t('Common.noEntitySelected')}}
      small.white--text {{$t('Common.selectEntityHelp')}}
  v-row(v-else)
    v-col.py-0
      v-card.px-10.py-5.my-5
        v-col.py-0.text-right
          v-btn(color="primary", @click="refresh") {{$t('Common.refresh')}}
            v-icon  mdi-refresh
        v-overlay(absolute, v-if="loading")
        g-data-table(
          dense,
          :headers="headers",
          :items="pagination.data",
          :options.sync="options",
          :server-items-length="pagination.total",
          v-bind="{ loading }",
        )
          template(v-slot:item.downloadJson="{ item }")
            v-btn(small, icon, @click="downloadMessage(item.uid)")
              v-icon.primary--text(small) mdi-download
          template(v-slot:item.downloadResponseContent="{ item }")
            v-btn(small, icon, @click="downloadResponseContent(item.uid)")
              v-icon.primary--text(small) mdi-download
          template(v-slot:top)
            app-entity-search(
              :criteria="$getInitialCriterias($route.params.criteria, pagination.where)",
              @pagination="pagination = $event",
              :loads="loads",
              :entity="entity",
            )
  v-row
    v-snackbar(v-model="snackbar")
      | {{ message }}
      v-btn(color="pink", text, @click="snackbar = false")
</template>

<style type="text/css">
.v-data-table td {
  white-space: nowrap;
}
.top-right {
  position: absolute;
  top: 1rem;
  right: .5rem;
}
</style>

<script>
import axios from 'axios'
import moment from 'moment-timezone'
import keys from 'lodash/keys'
import IndexFilterMixin from '@/mixins/index-filter.mixin';

export default {
  name: 'EdiLog-index',
  data: () => ({
    message: '',
    snackbar: false,
    loading: false,
    timer: null,
    wait: 500,
    pagination: {},
    options: {},
    loads: [],
  }),
  mixins: [
    IndexFilterMixin,
  ],
  watch: {
    $route: {
      immediate: true,
      handler () {
        this.clear();
        this.loads = _.get(ENV.ENTITIES, `${this.entityName}.index.add`, [])
          .filter(x => x.load)
          .map(x => x.load);
        this.load(this.options);
      }
    },
    options: {
      handler (options) {
        this.load(options)
      }
    }
  },

  computed: {
    has () {
      return !!this.items.length
    },
    entityName () {
      return 'EdiLog'
    },
    entity () {
      return this.$searchEntity(this.entityName, 'name')
    },
    headers() {
      return ([
        { text: this.$t("EdiLog.externalId"), value: "externalId" },
        { text: this.$t("EdiLog.createdAt"), value: "createdAt" },
        { text: this.$t("EdiLog.ediType"), value: "ediType" },
        { text: this.$t("EdiLog.itemExternalId"), value: "itemExternalId" },
        { text: this.$t("EdiLog.status"), value: "status" },
        { text: this.$t("EdiLog.businessScope"), value: "businessScope.path", "load": "BusinessScope" },
        { text: this.$t("EdiLog.reasonCode"), value: "reasonCode" },
        { text: this.$t("EdiLog.responseStatusCode"), value: "responseStatusCode" },
        { text: this.$t("EdiLog.responseUrl"), value: "responseUrl" },
        { text: this.$t("EdiLog.downloadEdiContent"), value: "downloadJson" },
        { text: this.$t("EdiLog.downloadResponse"), value: "downloadResponseContent" }
      ]);
    },
  },
  methods: {
    async downloadMessage(uid) {
      const newinstance = axios.create({  baseURL: process.env.VUE_APP_API_ABSOLUTE });
      var message = (await newinstance.get("Edi/GetMessage/" + uid)).data;
      var data = "data:text/plain;charset=utf-8," + encodeURIComponent(message);
      var downloadElement = document.createElement('a');
      downloadElement.setAttribute("href",     data);
      downloadElement.setAttribute("download", uid + "_message" + ".txt");
      document.body.appendChild(downloadElement);
      downloadElement.click();
      downloadElement.remove();
    },
    async downloadResponseContent(uid) {
      const newinstance = axios.create({  baseURL: process.env.VUE_APP_API_ABSOLUTE });
      var message = (await newinstance.get("Edi/GetResponseContent/" + uid)).data;
      var data = "data:text/plain;charset=utf-8," + encodeURIComponent(message);
      var downloadElement = document.createElement('a');
      downloadElement.setAttribute("href",     data);
      downloadElement.setAttribute("download", uid + "_responseContent" + ".txt");
      document.body.appendChild(downloadElement);
      downloadElement.click();
      downloadElement.remove();
    },
    getPagination(options = null, where = null) {
      options = options || this.options
      if (!keys(options).length) return
      return {
        params: {
          page: options.page,
          pageSize: options.itemsPerPage,
          orderBy: options.sortBy[0],
          desc: options.sortDesc[0],
          where: where,
        }
      }
    },
    /* TODO: docs */
    async load (options = null) {
      clearTimeout(this.timer)
      this.timer = setTimeout(async () => {
        const pagination = this.getPagination(options, this.pagination.where)
        if (this.entity) {
          this.loading = true
          var criteria = this.$route.params.criteria ? { Where: [this.$route.params.criteria.value] } : null
          pagination.params = {...pagination.params, ...criteria}
          try {
            const envEndpoint = _.get(ENV.ENTITIES, this.entityName  + '.index.endpoint', this.entityName);
            const envParams = _.get(ENV.ENTITIES, this.entityName  + '.index.params', {});
            pagination.params = _.merge(pagination.params, envParams);
            const paginationresult = (await axios.get(this.$fetchLoad(envEndpoint, ...this.loads), pagination)).data;
            paginationresult.data = (paginationresult.data || []).map(d => ({
              // The date should be a UTC format, otherwise it's not going to work.
              ...d,
              // TODO: implement env ignoreTimezone here, find a way to make it generic.
              createdAt: moment(d.createdAt).format('YYYY-MM-DD HH:mm'),
            }));
            this.pagination = paginationresult;
          } catch (err) {}
          this.loading = false
        }
      }, this.wait)
    },

    clear () {
      this.options = {
        ...this.options,
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
      };
    },

    refresh () {
      this.clear();
      this.load();
    }
  },
  created() {

  },
  mounted() {
      //
  }
}
</script>
